<template>
    <div class="sidebar" :style="{ width: sidebarWidth }">
        <transition name="fade">
            <div class="sidebar-content" v-if="sidebarState == 'expanded'">
                <div class="sidebar-toggle no-wrap">
                    <q-icon class="sidebar-toggle-button cursor-pointer" color="#ae312e" flat round size="md" name="menu"
                        @click="toggleSidebar('collapsed')"></q-icon>
                        <span class="text-h4 q-ml-md q-mt-sm">Te Kohinga</span>
                </div>
                <q-list>
                    <q-item class="sidebar-item" :class="{ 'active-link': isActive('/') }" clickable v-ripple
                        @click="redirectUser('clientDemographic')">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="o_people" size="30px" />
                        </q-item-section>
                        <q-item-section class="text-bold-600">Demographics</q-item-section>
                    </q-item>

                    <q-item class="sidebar-item" :class="{ 'active-link': isActive('dynamic-form') }" clickable v-ripple
                        @click="redirectUser('dynamicForm')">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="o_assignment" size="30px" />
                        </q-item-section>
                        <q-item-section class="text-bold-600">Client Forms</q-item-section>
                    </q-item>

                    <q-item class="sidebar-item" :class="{ 'active-link': isActive('client-form-data') }" clickable v-ripple
                        @click="redirectUser('clientFormData')">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="o_dashboard" size="30px" />
                        </q-item-section>
                        <q-item-section class="text-bold-600">Client Dashboard</q-item-section>
                    </q-item>

                    <q-item v-if="isDeveloper || hasFeature('asaIntegration')" class="sidebar-item hidden" :class="{ 'active-link': isActive('asa') }" clickable v-ripple
                        @click="redirectUser('asa')">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="o_school" size="30px" />
                        </q-item-section>
                        <q-item-section class="text-bold-600">ASA</q-item-section>
                    </q-item>

                    <q-item class="sidebar-item" :class="{ 'active-link': isActive('map') }" clickable v-ripple
                        @click="redirectUser('clientMap')">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="o_public" size="30px" />
                        </q-item-section>
                        <q-item-section class="text-bold-600">Map</q-item-section>
                    </q-item>

                    <q-item class="sidebar-item" :class="{ 'active-link': isActive('report') }" clickable v-ripple
                        @click="redirectUser('report')">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="o_description" size="30px" />
                        </q-item-section>
                        <q-item-section class="text-bold-600">Reports</q-item-section>
                    </q-item>

                    <q-item v-if="isDeveloper || hasFeature('clientEngagements')" class="sidebar-item" :class="{ 'active-link': isActive('tk-clients') }" clickable v-ripple
                        @click="redirectUser('tkClients')">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="o_group_work" size="30px" />
                        </q-item-section>
                        <q-item-section class="text-bold-600">Engagements</q-item-section>
                    </q-item>

                    <q-item v-if="isDeveloper" class="sidebar-item" :class="{ 'active-link': isActive('form-builder') }" clickable v-ripple
                        @click="redirectUser('formBuilder')">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="o_construction" size="30px" />
                        </q-item-section>
                        <q-item-section class="text-bold-600">Form Builder</q-item-section>
                    </q-item>

                    <q-item v-if="isAdmin || isDeveloper" class="sidebar-item" :class="{ 'active-link': isActive('triage-referral') }" clickable v-ripple
                        @click="redirectUser('triageReferral')">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="o_assignment_turned_in" size="30px" />
                        </q-item-section>
                        <q-item-section class="text-bold-600">Triage and Referral</q-item-section>
                    </q-item>

                    <q-item v-if="isTeamLeader || isAdmin || isDeveloper" class="sidebar-item" :class="{ 'active-link': isActive('admin/staff') }" clickable v-ripple
                        @click="redirectUser('adminDashboard')">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="o_admin_panel_settings" size="30px" />
                        </q-item-section>
                        <q-item-section class="text-bold-600">Admin Dashboard</q-item-section>
                    </q-item>

                    <q-item v-if="isDeveloper || (isAdmin && hasFeature('metrics'))" class="sidebar-item" :class="{ 'active-link': isActive('metrics') }" clickable v-ripple
                        @click="redirectUser('metrics')">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="o_insights" size="30px" />
                        </q-item-section>
                        <q-item-section class="text-bold-600">Metrics</q-item-section>
                    </q-item>

                </q-list>
                <div class="spacer"></div>
                <q-list>
                    <a style="color: white; text-decoration: none;" href="/Updated_TeKohingaGuide.pdf" target="_blank">
                        <q-item class="sidebar-item justify-center" clickable v-ripple>
                            <q-item-section class="sidebar-icon">
                                <q-icon name="o_menu_book" color="primary" size="30px" />
                            </q-item-section>
                            <q-item-section class="text-bold-600">User Guide</q-item-section>

                        </q-item>
                    </a>
                    <a style="color: white; text-decoration: none;" href="/TeItiKahurangiGuide.pdf" target="_blank">
                        <q-item class="sidebar-item justify-center" clickable v-ripple>
                            <q-item-section class="sidebar-icon">
                                <q-icon name="o_article" color="secondary" size="30px" />
                            </q-item-section>
                            <q-item-section class="text-bold-600">Form Guide</q-item-section>

                        </q-item>
                    </a>

                    <q-item class="sidebar-item" v-ripple clickable @click="logout()">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="logout" size="30px" />
                        </q-item-section>
                        <q-item-section class="text-bold-600">Logout</q-item-section>
                    </q-item>
                </q-list>
            </div>

            <div class="sidebar-content" v-else-if="sidebarState == 'collapsed'">
                <div class="sidebar-toggle" >
                    <q-icon class="sidebar-toggle-button cursor-pointer" color="white" flat round size="md" name="menu"
                        @click="toggleSidebar('expanded')"></q-icon>
                </div>
                <q-list>
                    <q-item class="sidebar-item" :class="{ 'active-link': isActive('/') }" clickable v-ripple
                        @click="redirectUser('clientDemographic')">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="o_people" size="30px" />
                        </q-item-section>
                    </q-item>

                    <q-item class="sidebar-item" :class="{ 'active-link': isActive('dynamic-form') }" clickable v-ripple
                        @click="redirectUser('dynamicForm')">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="o_assignment" size="30px" />
                        </q-item-section>
                    </q-item>

                    <q-item class="sidebar-item" :class="{ 'active-link': isActive('client-form-data') }" clickable v-ripple
                        @click="redirectUser('clientFormData')">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="o_dashboard" size="30px" />
                        </q-item-section>
                    </q-item>

                    <q-item v-if="isDeveloper || hasFeature('asaIntegration')" class="sidebar-item hidden" :class="{ 'active-link': isActive('asa') }" clickable v-ripple
                        @click="redirectUser('asa')">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="o_school" size="30px" />
                        </q-item-section>
                    </q-item>

                    <q-item class="sidebar-item" :class="{ 'active-link': isActive('map') }" clickable v-ripple
                        @click="redirectUser('clientMap')">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="o_public" size="30px" />
                        </q-item-section>
                    </q-item>

                    <q-item class="sidebar-item" :class="{ 'active-link': isActive('report') }" clickable v-ripple
                        @click="redirectUser('report')">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="o_description" size="30px" />
                        </q-item-section>
                    </q-item>

                    <q-item v-if="role !== 'client'" class="sidebar-item" :class="{ 'active-link': isActive('tk-clients') }" clickable v-ripple
                        @click="redirectUser('tkClients')">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="o_group_work" size="30px" />
                        </q-item-section>
                    </q-item>

                    <q-item v-if="isDeveloper" class="sidebar-item" :class="{ 'active-link': isActive('form-builder') }" clickable v-ripple
                        @click="redirectUser('formBuilder')">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="o_construction" size="30px" />
                        </q-item-section>
                    </q-item>

                    <q-item v-if="isAdmin || isDeveloper" class="sidebar-item" :class="{ 'active-link': isActive('triage-referral') }" clickable v-ripple
                        @click="redirectUser('triageReferral')">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="o_assignment_turned_in" size="30px" />
                        </q-item-section>
                    </q-item>

                    <q-item v-if="isTeamLeader || isAdmin || isDeveloper" class="sidebar-item" :class="{ 'active-link': isActive('admin/staff') }" clickable v-ripple
                        aria-label="Admin dashboard" @click="redirectUser('adminDashboard')">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="o_admin_panel_settings" size="30px" />
                        </q-item-section>
                        <q-tooltip anchor="center right" self="center left">Admin dashboard</q-tooltip>
                    </q-item>

                    <q-item v-if="isDeveloper || (isAdmin && hasFeature('metrics'))" class="sidebar-item" :class="{ 'active-link': isActive('metrics') }" clickable v-ripple
                        @click="redirectUser('metrics')">
                        <q-item-section class="sidebar-icon">
                            <q-icon name="o_insights" size="30px" />
                        </q-item-section>
                    </q-item>
                </q-list>

                <div class="spacer"></div>

                <a style="color: white; text-decoration: none;" href="/Updated_TeKohingaGuide.pdf" target="_blank">
                    <q-item class="sidebar-item justify-center" clickable v-ripple>
                        <q-item-section class="sidebar-icon">
                                <q-icon name="o_menu_book" color="primary" size="30px" />
                        </q-item-section>
                    </q-item>
                </a>

                <a style="color: white; text-decoration: none;" href="/TeItiKahurangiGuide.pdf" target="_blank">
                    <q-item class="sidebar-item justify-center" clickable v-ripple>
                        <q-item-section class="sidebar-icon">
                                <q-icon name="o_article" color="secondary" size="30px" />
                        </q-item-section>
                    </q-item>
                </a>

                <q-item class="sidebar-item justify-center" v-ripple clickable @click="logout()">
                    <q-item-section class="sidebar-icon">
                        <q-icon name="logout" size="30px" />
                    </q-item-section>
                </q-item>
            </div>

        </transition>
        <q-btn v-if="sidebarState == 'hidden'" class="sidebar-hidden-button sidebar-toggle-button cursor-pointer bg-grey-2"
            color="black" flat size="md" icon="menu" @click="toggleSidebar('expanded')"></q-btn>
    </div>
</template>

<script>
import { ref } from "vue";
import { sidebarState, toggleSidebar, sidebarWidth } from "./state";
import { Screen } from 'quasar'
import WebAppHelpModalVue from './WebAppHelpModal.vue'
import token from "@/services/util/roleHandler";
import { hasFeature } from "@/services/util/featureHandler";

export default {
    props: {},

    /**
     * @desc Setup the required variables for the sidebar and sites
     */
    setup() {
        return {
            sidebarState,
            toggleSidebar,
            sidebarWidth,
            expanded: ref(false),
        };
    },

    data() {
        return {
            role: token.getRole(),
            userEmail: token.getEmail(),
            isDeveloper: token.getRole() === 'developer',
            isAdmin: token.getRole() === 'admin',
            isTeamLeader: token.getRole() === 'team_leader',
            hasFeature,
        }
    },

    methods: {


        /**
         * Logs the user out
         * Resets the token and id of the user within local storage
         */
        logout() {
            this.isLogged = false;
            sessionStorage.clear();
            if (this.role == "client") {
                this.$router.push({ name: 'clientLogin' })
            } else {
                this.$router.push({ name: 'staffLogin' });
            }
        },

        /**
        * Opens up a modal
        * Displays information on how to use the web app.
        */
        help() {
            this.$q
                .dialog({
                    component: WebAppHelpModalVue,
                    parent: this,
                })
                .onOk(() => {
                    console.log("OK CLICKED");
                })
                .onCancel(() => {
                    console.log("Cancel");
                })
                .onDismiss(() => {
                    console.log("Called on OK or Cancel");
                });
        },

        isActive(route) {
            if (route === "/") {
                return this.$route.path === "/";
            }

            if (typeof route == "string") {
                return this.$route.path.includes(route);
            }

            return route.some((checkRoute) => this.$route.path.includes(checkRoute));
        },


        /**
         * @desc Redirects the user to the specified route. Hides dropdown if it's showing
         * @param {*} route The route to redirect to
         */
        redirectUser(route) {
            // If we are redirecting while viewing on mobile, close the sidebar.
            if (!Screen.gt.xs) {
                toggleSidebar('collapsed');
            }

            this.$router.push({ name: route });
        },
    }
}



</script>
    

    
<style scoped>
@import '../../assets/styles/sidebar.css';
</style>
